import React from 'react';

const packages = [
  {
    id: 1,
    title: 'Swift Dzire',
    location: '4 Seater - Comfortable and Fuel-Efficient Ride',
    seater: '4+1',
    price: 12, // Price per km
    oldPrice: 20,
    nightHaltPrice: 100, // Per night
    image: '/images/gallery/1.jpg',
  },
  {
    id: 2,
    title: 'Toyota Etios',
    location: '4 Seater - Smooth and Stylish City Ride',
    seater: '4+1',
    price: 13,
    oldPrice: 20,
    nightHaltPrice: 150,
    image: '/images/gallery/2.jpg',
  },
  {
    id: 3,
    title: 'Kia Carens',
    location: '6 Seater - Compact MPV with Comfort',
    seater: '6+1',
    price: 16,
    oldPrice: 20,
    nightHaltPrice: 150,
    image: '/images/gallery/3.jpg',
  },
  {
    id: 4,
    title: 'Ertiga',
    location: '7 Seater - Spacious Family Comfort',
    seater: '6+1',
    price: 15,
    oldPrice: 19,
    nightHaltPrice: 150,
    image: '/images/gallery/4.jpg',
  },
  {
    id: 5,
    title: 'Innova Cab',
    location: '7 Seater - Premium Ride for Long Journeys',
    seater: '6+1',
    price: 18,
    oldPrice: 25,
    nightHaltPrice: 200,
    image: '/images/gallery/5.jpg',
  },
  {
    id: 6,
    title: 'Innova Crysta',
    location: '7 Seater - Luxurious & Spacious Travel Experience',
    seater: '6+1',
    price: 20,
    oldPrice: 26,
    nightHaltPrice: 200,
    image: '/images/gallery/6.jpg',
  },

  {
    id: 4,
    title: '17 Seater Tempo Traveller',
    location: '7 Seater - Spacious Family Comfort',
    seater: '17',
    price: 25,
    oldPrice: 19,
    nightHaltPrice: 500,
    image: '/images/gallery/9.jpg',
  },
  {
    id: 5,
    title: '20 Seater Tempo Traveller',
    location: '7 Seater - Premium Ride for Long Journeys',
    seater: '20',
    price: 25,
    oldPrice: 25,
    nightHaltPrice: 500,
    image: '/images/gallery/10.jpg',
  },
  {
    id: 6,
    title: '32 Seater Bus',
    location: '7 Seater - Luxurious & Spacious Travel Experience',
    seater: '32',
    price: 35,
    oldPrice: 26,
    nightHaltPrice: 500,
    image: '/images/gallery/11.jpg',
  },
];



const Booking = () => {
  const handleWhatsApp = (cabName) => {
    const message = `Hi, I am interested in booking the ${cabName}. Could you please provide more details?`;
    const phoneNumber = '919284304420';
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };



  return (
    <>




      <section className="inner-banner-wrap">
        <div
          className="inner-baner-container"
          style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
        >
          <div className="container">
            <div className="inner-banner-content">
              <h1 className="inner-title">Booking</h1>
            </div>
          </div>
        </div>
        <div className="inner-shape"></div>
      </section>








      <section className="vs-tour-package style-3 bg-third-theme-14 space border">


        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-md-6 col-lg-6 col-xxl-5">
              {/* Additional Content */}
            </div>
          </div>

          <div className="row mt-4">
            {packages.map((pkg) => (
              <div className="col-md-6 col-lg-4 py-2" key={pkg.id}>
                <div
                  className="tour-package-box bg-white-color"
                  style={{
                    border: '2px solid #B03224',
                    borderRadius: '10px',
                    overflow: 'hidden',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  <div className="tour-package-thumb borderrr">
                    <img src={pkg.image} alt={pkg.title} className="w-100" />
                  </div>
                  <div className="tour-package-content " style={{ padding: '20px' }}>
                    <h5
                      className="title line-clamp-2 text-center bg-warn"
                      style={{ color: '#B03224', fontWeight: 'bold' }}
                    >
                      <a
                        href={pkg.link}

                        style={{ color: '#B03224', textDecoration: 'none' }}
                      >
                        {pkg.title}
                      </a>
                    </h5>
                    <p
                      style={{
                        color: '#666',
                        fontSize: '14px',
                        marginBottom: '10px',
                      }}
                    >
                      {/* {pkg.location} */}
                    </p>
                    <div className="pricing-container" style={{ marginBottom: '15px' }}>
                      <div className="package-time">
                        <div className="package-detail">
                          <span className="package-label" style={{ color: '#B03224' }}>
                            Seater:
                          </span>
                          <span className="package-value">{pkg.seater}</span>
                        </div>
                        <div className="package-detail">
                          <span className="package-label" style={{ color: '#B03224' }}>
                            Per Km:
                          </span>
                          <span
                            className="package-value"
                            style={{ color: '#B03224', fontWeight: 'bold' }}
                          >
                            ₹{pkg.price}
                          </span>
                        </div>
                        <div className="package-detail">
                          <span className="package-label" style={{ color: '#B03224' }}>
                            Extra Hr:
                          </span>
                          <span className="package-value">{pkg.nightHaltPrice}</span>
                        </div>
                       
                      </div>
                    </div>
                    <button
                      onClick={() => handleWhatsApp(pkg.title)}
                      className="vs-btn style7 w-100"
                      style={{
                        backgroundColor: '#F59B29',
                        color: '#fff',
                        border: 'none',
                        padding: '10px 15px',
                        fontWeight: 'bold',
                        borderRadius: '5px',
                      }}
                    >
                      Book Now
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Booking;
